(function($) {
  /**
   * Thing to do page
   */
  var thingCarousel = new Swiper('.things-carousel', {
    loop: false,
    spaceBetween: 20,
    slidesPerView: 3,
    slidesPerGroup: 3,
    pagination: {
        el: '.swiper-pagination'
    },
    breakpoints: {
        575: {
            slidesPerView: 1,
            slidesPerGroup: 1
        },
        767: {
            slidesPerView: 2,
            slidesPerGroup: 2
        }
      }
  });
})(jQuery);